import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
// import { queryConfigItem } from 'store/siteConfig'

// ------------------------------------
// Constants
// ------------------------------------
export const MOBILE_TOP_UP_TOP_UP_DAY = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
}, 'MOBILE_TOP_UP_TOP_UP_DAY')

// ------------------------------------
// Actions
// ------------------------------------
export function init() {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/event/kyc-fission/v1/auth/activity/detail',
        method: 'POST',
        body: {
          scenesCode: 'TOPUP_DAY'
        },
        requestAction: MOBILE_TOP_UP_TOP_UP_DAY.INIT_REQUEST,
        successAction: MOBILE_TOP_UP_TOP_UP_DAY.INIT_SUCCESS,
        success: function(result) {
          // const { bizData = {} } = result.commandData
          // if (bizData.activityStatus === 'N' || !bizData.dday) {
          //   dispatch(queryConfigItem({ itemKey: 'PROMOTE_VOUCHER_WEEKLY' })) // 活动未开始或结束时查询
          // }
        }
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [MOBILE_TOP_UP_TOP_UP_DAY.INIT_REQUEST]: (state, action) => state,
  [MOBILE_TOP_UP_TOP_UP_DAY.INIT_SUCCESS]: (state, action) => {
    const { commandData = {} } = action.payload
    return Object.assign({}, state, action.payload, { ...commandData })
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'mobileTopUpTopUpDay',
    reducerMap: {
      mobileTopUpTopUpDayState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
